export const CREATE_REPORT_MODAL_WIDTH = 716;
export const CREATE_TEMPLATE_REPORT_MODAL_WIDTH = 516;
export const CREATE_TEMPLATE_MODAL_WIDTH = 550;
export const CREATE_ACTION_MODAL_WIDTH = 550;
export const CONFIRM_QUIT_MODAL_WIDTH = 530; //we need this because the standard 500px isn't enough for German translation
export const INTEGRATIONS_SINGLE_STEP_CONFIRMATION_MODAL_WIDTH = 550;
export const MOBILE_APP_POPUP_MODAL_WIDTH = 680;
export const ENTITIES_UPLOAD_MODAL = 680;
export const CREATE_HUBSPOT_TICKET_MODAL_WIDTH = 520;
export const SESSION_LIMITATION_MODAL_WIDTH = 680;
export const CREATE_SCHEDULE_MODAL_WIDTH = 550;
export const TIME_WINDOW_MODAL_WIDTH = 630;
export const ANALYTICS_FILE_ITEMS_MODAL_WIDTH = 450;
export const START_FREE_TRIAL_MODAL_WIDTH = 611;
export const CANCEL_SUBSCRIPTION_MODAL_WIDTH = 600;
export const SEND_REPORT_BY_EMAIL_MODAL_WIDTH = 550;
export const CANNOT_ADD_SEATS_MODAL_WIDTH = 465;
export const LINK_PROMPT_MODAL_WIDTH = 540;
export const CREATE_COURSE_MODAL_WIDTH = 540;
export const START_COURSE_MODAL_WIDTH = 540;
export const DROPDOWN_RESPONSE_SET_MODAL_WIDTH = 550;
export const PREFILL_ENTITY_PROPERTY_MODAL_WIDTH = 460;
export const AI_TRANSLATION_CONFIRM_MODAL_WIDTH = 530;
